const EstimationScenarioTypes = {
  LOW: "low",
  EXPECTED: "expected",
  POTENTIAL: "potential"
} as const;

const ALL = Object.values(EstimationScenarioTypes);

export default { ...EstimationScenarioTypes, ALL };
